import html2pdf from 'html2pdf.js';

export const generatePDFFromHTML = async (htmlContent: string, fileName: string = 'curriculo'): Promise<void> => {
  try {
    const options = {
      margin: [19, 19, 19, 10] as [number, number, number, number],
      filename: `${fileName}.pdf`,
      image: { 
        type: 'jpeg' as const, 
        quality: 0.98 
      },
      html2canvas: { 
        scale: 1.5,
        useCORS: true,
        letterRendering: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        width: 720,
        dpi: 96,
        logging: false,
        scrollX: 0,
        scrollY: 0,
        windowWidth: 816,
        windowHeight: 1200
      },
      jsPDF: { 
        unit: 'mm', 
        format: 'a4', 
        orientation: 'portrait' as const,
        compress: true
      },
      pagebreak: { 
        mode: ['css', 'legacy'],
        avoid: ['tr', 'img']
      }
    };
    
    await html2pdf().set(options).from(htmlContent).save();
    
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
    throw new Error('Erro ao gerar PDF. Tente novamente.');
  }
};

export const previewCurriculumHTML = (htmlContent: string, fileName: string = 'curriculo'): void => {
  const previewWindow = window.open('', '_blank', 'width=900,height=1200,scrollbars=yes');
  if (!previewWindow) {
    throw new Error('Não foi possível abrir janela de preview');
  }
  
  const htmlWithPreviewControls = htmlContent.replace(
    '<body>',
    `<body>
      <div style="position: fixed; top: 10px; right: 10px; z-index: 9999; background: rgba(0,0,0,0.8); padding: 10px; border-radius: 8px;">
        <button onclick="window.close()" style="background: #e74c3c; color: white; border: none; padding: 8px 16px; margin: 0 5px; border-radius: 4px; cursor: pointer; font-size: 14px;">
          ❌ Fechar
        </button>
      </div>`
  );
  
  previewWindow.document.write(htmlWithPreviewControls);
  previewWindow.document.close();
  previewWindow.document.title = `Preview - ${fileName}`;
};